module.exports = __webpack_public_path__ + "static/media/horizontal_logo_645_145.0b22f07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/horizontal_logo_645_145.png
// module id = 571
// module chunks = 0